import { useTranslation } from 'react-i18next';

export const useModuleTranslation = () => useTranslation(['dataentry', 'commons']);
